import React from 'react';
import { PatientCareCenterNoteGoalsBody } from 'PatientCareCenter/Note/WorkProgram/Goals'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { PatientCareCenterNoteNavAnchor } from '../../NavAnchor';
class PatientCareCenterNoteWpGoals extends React.Component {

    render() {
        return (
            <>
              <PatientCareCenterNoteNavAnchor id='GoalsSection' />
                <PatientCareCenterNoteSection id='goals' name='Goals' refProp={this.props.refProp} level={5}>
                <PatientCareCenterNoteGoalsBody subjectiveRefProp={this.props.subjectiveRefProp} />
              </PatientCareCenterNoteSection>
              </>
           
        );
    }

}

export { PatientCareCenterNoteWpGoals };

